import React from "react";
import { Card, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import emailImg from "../../../assets/images/statistics/Emails.png";
import OutboundCalls from "../../../assets/images/statistics/OutboundCalls.png";
import TextMessages from "../../../assets/images/statistics/TextMessages.png";
import Clients from "../../../assets/images/statistics/Clients.png";
import Submitted from "../../../assets/images/statistics/greenback.svg";
import Recent from "../../../assets/images/statistics/recent.svg";
import { NumberFormatter, commonApiCall, decryptData } from "../../../utlis";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const TopPerformerStatics = ({ statsData }) => {

  const returnPopOver = (id, header, content) => {
    return (
      <Popover id={id}>
        {header !== "" && (
          <Popover.Content className='pb-0'>
            <strong>{header}</strong>
          </Popover.Content>
        )}
        <Popover.Content>{content}</Popover.Content>
      </Popover>
    );
  };

  return (
    <div className='dashboard-box-wrap mt-3 mb-xl-3 mb-0  py-1'>
      <Row>
        <Col lg={6} xl={6} className=' mb-3'>
          <Card className='p-2 d-flex justify-content-center' style={{ minHeight: "83px" }}>
            <div className='align-items-center icon-box with-users d-flex text-left'>
              <div style={{height : "35px"}} className='d-flex align-items-center position-relative justify-content-center'>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement='bottom'
                  overlay={returnPopOver(
                    "popover-basic",
                    "",
                    statsData?.data?.clientCount
                      ?.map(
                        (obj) =>
                          decryptData(obj.FirstName) +
                          " " +
                          decryptData(obj.Lastname)
                      )
                      .join(", ")
                  )}
                >
                  <div className='user flex-shrink-0'>
                    {statsData?.data?.clientCount
                      .slice(0, 2)
                      ?.map((emailData, ind) => (
                        <img
                          key={ind}
                          src={
                            emailData?.ProfilePic ||
                            "/assets/images/no-image.jpg"
                          }
                          width={45}
                          height={45}
                          className={ind == 1 ? "margin-left-minos" : ""}
                          alt=''
                        />
                      ))}
                    {statsData?.data?.clientCount?.length > 2 && (
                      <span className='more font-18'>
                        +{statsData?.data?.clientCount?.length - 2}
                      </span>
                    )}
                  </div>
                </OverlayTrigger>

                <img
                  className='sidebar-logo-image'
                  src={Clients}
                  alt='Total Clients'
                  width={22}
                  height={22}
                ></img>
              </div>
              <div className='box-info ml-2'>
                <h3 className='font-12 font-weight-semibold  line-height-initial m-0  text-color-black text-left'>
                  <span>
                    {statsData?.data?.clientCount
                      ?.slice(0, 2)
                      ?.map(
                        (obj) =>
                          decryptData(obj?.FirstName) +
                          " " +
                          decryptData(obj?.Lastname)
                      )
                      .join(", ")}
                  </span>
                </h3>
                <div className='box-info m-0' >
                  <h5 className=' font-12 font-semibold mt-1 mb-0 line-height-initial d-flex align-items-baseline'>
                    <span className='align-middle font-18 lh-0 mr-1 text-black-color '>
                      {statsData?.clientCount
                        ? NumberFormatter(statsData?.clientCount, "", "", false)
                        : 0}
                    </span>{" "}
                    Total Applicants
                    {/* <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement='bottom'
                      overlay={returnPopOver(
                        "popover-basic",
                        "Total Clients",
                        "Agent with most Total Clients"
                      )}
                    >
                      <span className='list-info cursor-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          version='1.1'
                          width='13px'
                          height='13px'
                          className='ml-2 mb-1'
                        >
                          <g transform='matrix(1 0 0 1 -528 -225 )'>
                            <path
                              d='M 5.8500000000000005 9.1  L 5.8500000000000005 10.4  L 7.15 10.4  L 7.15 9.1  L 5.8500000000000005 9.1  Z M 8.987442541122435 0.4947830677032471  C 8.198826217651368 0.16812750101089477  7.353592163324356 0  6.5 0  C 5.646407836675643 0  4.801173782348633 0.16812750101089477  4.012557458877564 0.4947830677032471  C 3.2239411354064944 0.8214386343955994  2.5073867112398145 1.3002251356840133  1.903805923461914 1.903805923461914  C 0.6848194360733032 3.122792410850525  0 4.7760927915573115  0 6.5  C 0 8.223907208442688  0.6848194360733032 9.877207589149476  1.903805923461914 11.096194076538085  C 2.5073867112398145 11.699774864315986  3.2239411354064944 12.178561985492706  4.012557458877564 12.505217552185059  C 4.801173782348633 12.831873118877411  5.646407836675643 12.999999999999996  6.5 13  C 8.223907208442688 12.999999999999996  9.877207589149476 12.315180563926697  11.096194076538085 11.096194076538085  C 12.315180563926697 9.877207589149476  13 8.223907208442688  13 6.5  C 13 5.646407836675643  12.831873118877411 4.801173782348633  12.505217552185059 4.012557458877564  C 12.178561985492706 3.2239411354064944  11.699774864315986 2.5073867112398145  11.096194076538085 1.903805923461914  C 10.492613288760184 1.3002251356840133  9.776058864593507 0.8214386343955994  8.987442541122435 0.4947830677032471  Z M 11.700000000000001 6.5  C 11.700000000000001 9.366499900817871  9.366499900817871 11.700000000000001  6.5 11.700000000000001  C 3.633500099182129 11.700000000000001  1.3 9.366499900817871  1.3 6.5  C 1.3 3.633500099182129  3.633500099182129 1.3  6.5 1.3  C 9.366499900817871 1.3  11.700000000000001 3.633500099182129  11.700000000000001 6.5  Z M 8.338477754592896 3.3615222454071043  C 7.850883182883263 2.8739276736974717  7.189562898874283 2.6000000000000005  6.5 2.6  C 5.810437101125717 2.6000000000000005  5.149116817116737 2.8739276736974717  4.661522245407105 3.3615222454071043  C 4.173927673697471 3.8491168171167374  3.900000000000002 4.510437101125717  3.9 5.2  C 3.9 5.2  5.2 5.2  5.2 5.2  C 5.2 4.855218550562859  5.336964146792888 4.524558718502521  5.580761432647705 4.280761432647705  C 5.824558718502522 4.036964146792889  6.155218550562858 3.899999999999999  6.5 3.9  C 6.844781449437141 3.899999999999999  7.175441281497479 4.036964146792889  7.419238567352295 4.280761432647705  C 7.663035853207111 4.524558718502521  7.8 4.855218550562859  7.8 5.2  C 7.8 6.5  5.8500000000000005 6.3374999999999995  5.8500000000000005 8.450000000000001  C 5.8500000000000005 8.450000000000001  7.15 8.450000000000001  7.15 8.450000000000001  C 7.15 6.9875  9.1 6.825  9.1 5.2  C 9.1 4.510437101125717  8.826072326302528 3.8491168171167374  8.338477754592896 3.3615222454071043  Z '
                              fillRule='nonzero'
                              fill='#9b9b9b'
                              stroke='none'
                              transform='matrix(1 0 0 1 528 225 )'
                            />
                          </g>
                        </svg>
                      </span>
                    </OverlayTrigger> */}
                  </h5>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={6} xl={6} className=' mb-3'>
          <Card className='p-2 d-flex justify-content-center' style={{ minHeight: "83px" }}>
            <div className=' align-items-center icon-box with-users d-flex text-left'>
              <div style={{height : "35px"}} className='d-flex align-items-center position-relative justify-content-center'>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement='bottom'
                  overlay={returnPopOver(
                    "popover-basic",
                    "",
                    statsData?.data?.policiesPaidCount
                      ?.map(
                        (obj) =>
                          decryptData(obj.FirstName) +
                          " " +
                          decryptData(obj.Lastname)
                      )
                      .join(", ")
                  )}
                >
                  <div className='user flex-shrink-0'>
                    {statsData?.data?.policiesPaidCount
                      .slice(0, 2)
                      ?.map((callData, ind) => (
                        <img
                          key={ind}
                          src={
                            callData?.ProfilePic ||
                            "/assets/images/no-image.jpg"
                          }
                          width={45}
                          height={45}
                          className={ind == 1 ? "margin-left-minos" : ""}
                          alt=''
                        />
                      ))}
                    {statsData?.data?.policiesPaidCount?.length > 2 && (
                      <span className='more font-18'>
                        +{statsData?.data?.policiesPaidCount?.length - 2}
                      </span>
                    )}
                  </div>
                </OverlayTrigger>

                <img
                  className='sidebar-logo-image'
                  src={emailImg}
                  alt='Calls Made'
                  width={22}
                  height={22}
                ></img>
              </div>
              <div className='box-info ml-2'>
                <h3 className='font-12 font-weight-semibold  line-height-initial m-0  text-color-black text-left'>
                  <span>
                    {statsData?.data?.policiesPaidCount
                      ?.slice(0, 2)
                      ?.map(
                        (obj) =>
                          decryptData(obj?.FirstName) +
                          " " +
                          decryptData(obj?.Lastname)
                      )
                      .join(", ")}
                  </span>{" "}
                </h3>
                <div className='box-info m-0' >
                  <h5 className=' font-12 font-semibold mt-1 mb-0 line-height-initial d-flex align-items-baseline'>
                    <span className='font-18 align-middle lh-0 mr-1 text-black-color '>
                      {statsData?.policiesPaidCount
                        ? NumberFormatter(
                            statsData.policiesPaidCount,
                            "",
                            "",
                            false
                          )
                        : 0}
                    </span>{" "}
                    Policies Paid
                    {/* <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement='bottom'
                      overlay={returnPopOver(
                        "popover-basic",
                        "Policies Paid",
                        "Agent with most Policies Paid"
                      )}
                    >
                      <span className='list-info cursor-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          version='1.1'
                          width='13px'
                          height='13px'
                          className='ml-2 mb-1'
                        >
                          <g transform='matrix(1 0 0 1 -528 -225 )'>
                            <path
                              d='M 5.8500000000000005 9.1  L 5.8500000000000005 10.4  L 7.15 10.4  L 7.15 9.1  L 5.8500000000000005 9.1  Z M 8.987442541122435 0.4947830677032471  C 8.198826217651368 0.16812750101089477  7.353592163324356 0  6.5 0  C 5.646407836675643 0  4.801173782348633 0.16812750101089477  4.012557458877564 0.4947830677032471  C 3.2239411354064944 0.8214386343955994  2.5073867112398145 1.3002251356840133  1.903805923461914 1.903805923461914  C 0.6848194360733032 3.122792410850525  0 4.7760927915573115  0 6.5  C 0 8.223907208442688  0.6848194360733032 9.877207589149476  1.903805923461914 11.096194076538085  C 2.5073867112398145 11.699774864315986  3.2239411354064944 12.178561985492706  4.012557458877564 12.505217552185059  C 4.801173782348633 12.831873118877411  5.646407836675643 12.999999999999996  6.5 13  C 8.223907208442688 12.999999999999996  9.877207589149476 12.315180563926697  11.096194076538085 11.096194076538085  C 12.315180563926697 9.877207589149476  13 8.223907208442688  13 6.5  C 13 5.646407836675643  12.831873118877411 4.801173782348633  12.505217552185059 4.012557458877564  C 12.178561985492706 3.2239411354064944  11.699774864315986 2.5073867112398145  11.096194076538085 1.903805923461914  C 10.492613288760184 1.3002251356840133  9.776058864593507 0.8214386343955994  8.987442541122435 0.4947830677032471  Z M 11.700000000000001 6.5  C 11.700000000000001 9.366499900817871  9.366499900817871 11.700000000000001  6.5 11.700000000000001  C 3.633500099182129 11.700000000000001  1.3 9.366499900817871  1.3 6.5  C 1.3 3.633500099182129  3.633500099182129 1.3  6.5 1.3  C 9.366499900817871 1.3  11.700000000000001 3.633500099182129  11.700000000000001 6.5  Z M 8.338477754592896 3.3615222454071043  C 7.850883182883263 2.8739276736974717  7.189562898874283 2.6000000000000005  6.5 2.6  C 5.810437101125717 2.6000000000000005  5.149116817116737 2.8739276736974717  4.661522245407105 3.3615222454071043  C 4.173927673697471 3.8491168171167374  3.900000000000002 4.510437101125717  3.9 5.2  C 3.9 5.2  5.2 5.2  5.2 5.2  C 5.2 4.855218550562859  5.336964146792888 4.524558718502521  5.580761432647705 4.280761432647705  C 5.824558718502522 4.036964146792889  6.155218550562858 3.899999999999999  6.5 3.9  C 6.844781449437141 3.899999999999999  7.175441281497479 4.036964146792889  7.419238567352295 4.280761432647705  C 7.663035853207111 4.524558718502521  7.8 4.855218550562859  7.8 5.2  C 7.8 6.5  5.8500000000000005 6.3374999999999995  5.8500000000000005 8.450000000000001  C 5.8500000000000005 8.450000000000001  7.15 8.450000000000001  7.15 8.450000000000001  C 7.15 6.9875  9.1 6.825  9.1 5.2  C 9.1 4.510437101125717  8.826072326302528 3.8491168171167374  8.338477754592896 3.3615222454071043  Z '
                              fillRule='nonzero'
                              fill='#9b9b9b'
                              stroke='none'
                              transform='matrix(1 0 0 1 528 225 )'
                            />
                          </g>
                        </svg>
                      </span>
                    </OverlayTrigger> */}
                  </h5>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={6} xl={6} className=' mb-3'>
          <Card className='p-2 d-flex justify-content-center' style={{ minHeight: "83px" }}>
            <div className='icon-box align-items-center  with-users d-flex text-left'>
              <div style={{height : "35px"}} className='d-flex align-items-center position-relative justify-content-center'>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement='bottom'
                  overlay={returnPopOver(
                    "popover-basic",
                    "",
                    statsData?.data?.submittedAppCnt
                      ?.map(
                        (obj) =>
                          decryptData(obj.FirstName) +
                          " " +
                          decryptData(obj.Lastname)
                      )
                      .join(", ")
                  )}
                >
                  <div className='user flex-shrink-0'>
                    {statsData?.data?.submittedAppCnt
                      .slice(0, 2)
                      ?.map((textData, ind) => (
                        <img
                          key={ind}
                          src={
                            textData?.ProfilePic ||
                            "/assets/images/no-image.jpg"
                          }
                          width={45}
                          height={45}
                          className={ind == 1 ? "margin-left-minos" : ""}
                          alt=''
                        />
                      ))}
                    {statsData?.data?.submittedAppCnt?.length > 2 && (
                      <span className='more font-18'>
                        +{statsData?.data?.submittedAppCnt?.length - 2}
                      </span>
                    )}
                  </div>
                </OverlayTrigger>

                <img
                  className='sidebar-logo-image'
                  src={Submitted}
                  alt='Text Messages Sent'
                  width={22}
                  height={22}
                ></img>
              </div>
              <div className='box-info ml-2'>
                <h3 className='font-12 font-weight-semibold  line-height-initial m-0  text-color-black text-left'>
                  <span>
                    {statsData?.data?.submittedAppCnt

                      .slice(0, 2)
                      ?.map(
                        (obj) =>
                          decryptData(obj?.FirstName) +
                          " " +
                          decryptData(obj?.Lastname)
                      )
                      .join(", ")}
                  </span>
                </h3>
                <div className='box-info m-0' >
                  <h5 className=' font-12 font-semibold mt-1 mb-0 line-height-initial d-flex align-items-baseline'>
                    <span className='align-middle font-18 lh-0 mr-1 text-black-color '>
                      {statsData?.submittedCount
                        ? NumberFormatter(
                            statsData.submittedCount,
                            "",
                            "",
                            false
                          )
                        : 0}
                    </span>{" "}
                    Submitted Apps
                    {/* <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement='bottom'
                      overlay={returnPopOver(
                        "popover-basic",
                        "Submitted Apps",
                        "Agent with most Submitted Apps"
                      )}
                    >
                      <span className='list-info cursor-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          version='1.1'
                          width='13px'
                          height='13px'
                          className='ml-2 mb-1'
                        >
                          <g transform='matrix(1 0 0 1 -528 -225 )'>
                            <path
                              d='M 5.8500000000000005 9.1  L 5.8500000000000005 10.4  L 7.15 10.4  L 7.15 9.1  L 5.8500000000000005 9.1  Z M 8.987442541122435 0.4947830677032471  C 8.198826217651368 0.16812750101089477  7.353592163324356 0  6.5 0  C 5.646407836675643 0  4.801173782348633 0.16812750101089477  4.012557458877564 0.4947830677032471  C 3.2239411354064944 0.8214386343955994  2.5073867112398145 1.3002251356840133  1.903805923461914 1.903805923461914  C 0.6848194360733032 3.122792410850525  0 4.7760927915573115  0 6.5  C 0 8.223907208442688  0.6848194360733032 9.877207589149476  1.903805923461914 11.096194076538085  C 2.5073867112398145 11.699774864315986  3.2239411354064944 12.178561985492706  4.012557458877564 12.505217552185059  C 4.801173782348633 12.831873118877411  5.646407836675643 12.999999999999996  6.5 13  C 8.223907208442688 12.999999999999996  9.877207589149476 12.315180563926697  11.096194076538085 11.096194076538085  C 12.315180563926697 9.877207589149476  13 8.223907208442688  13 6.5  C 13 5.646407836675643  12.831873118877411 4.801173782348633  12.505217552185059 4.012557458877564  C 12.178561985492706 3.2239411354064944  11.699774864315986 2.5073867112398145  11.096194076538085 1.903805923461914  C 10.492613288760184 1.3002251356840133  9.776058864593507 0.8214386343955994  8.987442541122435 0.4947830677032471  Z M 11.700000000000001 6.5  C 11.700000000000001 9.366499900817871  9.366499900817871 11.700000000000001  6.5 11.700000000000001  C 3.633500099182129 11.700000000000001  1.3 9.366499900817871  1.3 6.5  C 1.3 3.633500099182129  3.633500099182129 1.3  6.5 1.3  C 9.366499900817871 1.3  11.700000000000001 3.633500099182129  11.700000000000001 6.5  Z M 8.338477754592896 3.3615222454071043  C 7.850883182883263 2.8739276736974717  7.189562898874283 2.6000000000000005  6.5 2.6  C 5.810437101125717 2.6000000000000005  5.149116817116737 2.8739276736974717  4.661522245407105 3.3615222454071043  C 4.173927673697471 3.8491168171167374  3.900000000000002 4.510437101125717  3.9 5.2  C 3.9 5.2  5.2 5.2  5.2 5.2  C 5.2 4.855218550562859  5.336964146792888 4.524558718502521  5.580761432647705 4.280761432647705  C 5.824558718502522 4.036964146792889  6.155218550562858 3.899999999999999  6.5 3.9  C 6.844781449437141 3.899999999999999  7.175441281497479 4.036964146792889  7.419238567352295 4.280761432647705  C 7.663035853207111 4.524558718502521  7.8 4.855218550562859  7.8 5.2  C 7.8 6.5  5.8500000000000005 6.3374999999999995  5.8500000000000005 8.450000000000001  C 5.8500000000000005 8.450000000000001  7.15 8.450000000000001  7.15 8.450000000000001  C 7.15 6.9875  9.1 6.825  9.1 5.2  C 9.1 4.510437101125717  8.826072326302528 3.8491168171167374  8.338477754592896 3.3615222454071043  Z '
                              fillRule='nonzero'
                              fill='#9b9b9b'
                              stroke='none'
                              transform='matrix(1 0 0 1 528 225 )'
                            />
                          </g>
                        </svg>
                      </span>
                    </OverlayTrigger> */}
                  </h5>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col lg={6} xl={6} className=' mb-3'>
          <Card className='p-2 d-flex justify-content-center' style={{ minHeight: "83px" }}>
            <div className='icon-box align-items-center  with-users d-flex text-left'>
              <div style={{height : "35px"}} className='d-flex align-items-center position-relative justify-content-center'>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement='bottom'
                  overlay={returnPopOver(
                    "popover-basic",
                    "",
                    statsData?.data?.recentActivitiesCount?.map(
                        (obj) =>
                          decryptData(obj.FirstName) +
                          " " +
                          decryptData(obj.Lastname)
                      )
                      .join(", ")
                  )}
                >
                  <div className='user flex-shrink-0'>
                    {statsData?.data?.recentActivitiesCount?.slice(0, 2)
                      ?.map((clientData, ind) => (
                        <img
                          key={ind}
                          src={
                            clientData?.ProfilePic ||
                            "/assets/images/no-image.jpg"
                          }
                          width={45}
                          height={45}
                          className={ind == 1 ? "margin-left-minos" : ""}
                          alt=''
                        />
                      ))}
                    {statsData?.data?.recentActivitiesCount?.length > 2 && (
                      <span className='more font-18'>
                        +{statsData?.data?.recentActivitiesCount?.length - 2}
                      </span>
                    )}
                  </div>
                </OverlayTrigger>

                <img
                  className='sidebar-logo-image'
                  src={Recent}
                  alt='Total Clients'
                  width={22}
                  height={22}
                ></img>
              </div>
              <div className='box-info ml-2'>
                <h3 className='font-12 font-weight-semibold line-height-initial m-0  text-color-black text-left'>
                  <span>
                    {statsData?.data?.recentActivitiesCount?.slice(0, 2)
                      ?.map(
                        (obj) =>
                          decryptData(obj?.FirstName) +
                          " " +
                          decryptData(obj?.Lastname)
                      )
                      .join(", ")}
                  </span>{" "}
                </h3>
                <div className='box-info m-0' >
                  <h5 className=' font-12 font-semibold mt-1 mb-0 line-height-initial d-flex align-items-baseline'>
                    <span className='align-middle font-18 lh-0 mr-1 text-black-color '>
                      {statsData?.recentActivitiesCount
                        ? NumberFormatter(statsData?.recentActivitiesCount, "", "", false)
                        : 0}
                    </span>{" "}
                    Recent Activities
                    {/* <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement='bottom'
                      overlay={returnPopOver(
                        "popover-basic",
                        "Recent Activities",
                        "Agent with the most activity"
                      )}
                    >
                      <span className='list-info cursor-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          version='1.1'
                          width='13px'
                          height='13px'
                          className='ml-2 mb-1'
                        >
                          <g transform='matrix(1 0 0 1 -528 -225 )'>
                            <path
                              d='M 5.8500000000000005 9.1  L 5.8500000000000005 10.4  L 7.15 10.4  L 7.15 9.1  L 5.8500000000000005 9.1  Z M 8.987442541122435 0.4947830677032471  C 8.198826217651368 0.16812750101089477  7.353592163324356 0  6.5 0  C 5.646407836675643 0  4.801173782348633 0.16812750101089477  4.012557458877564 0.4947830677032471  C 3.2239411354064944 0.8214386343955994  2.5073867112398145 1.3002251356840133  1.903805923461914 1.903805923461914  C 0.6848194360733032 3.122792410850525  0 4.7760927915573115  0 6.5  C 0 8.223907208442688  0.6848194360733032 9.877207589149476  1.903805923461914 11.096194076538085  C 2.5073867112398145 11.699774864315986  3.2239411354064944 12.178561985492706  4.012557458877564 12.505217552185059  C 4.801173782348633 12.831873118877411  5.646407836675643 12.999999999999996  6.5 13  C 8.223907208442688 12.999999999999996  9.877207589149476 12.315180563926697  11.096194076538085 11.096194076538085  C 12.315180563926697 9.877207589149476  13 8.223907208442688  13 6.5  C 13 5.646407836675643  12.831873118877411 4.801173782348633  12.505217552185059 4.012557458877564  C 12.178561985492706 3.2239411354064944  11.699774864315986 2.5073867112398145  11.096194076538085 1.903805923461914  C 10.492613288760184 1.3002251356840133  9.776058864593507 0.8214386343955994  8.987442541122435 0.4947830677032471  Z M 11.700000000000001 6.5  C 11.700000000000001 9.366499900817871  9.366499900817871 11.700000000000001  6.5 11.700000000000001  C 3.633500099182129 11.700000000000001  1.3 9.366499900817871  1.3 6.5  C 1.3 3.633500099182129  3.633500099182129 1.3  6.5 1.3  C 9.366499900817871 1.3  11.700000000000001 3.633500099182129  11.700000000000001 6.5  Z M 8.338477754592896 3.3615222454071043  C 7.850883182883263 2.8739276736974717  7.189562898874283 2.6000000000000005  6.5 2.6  C 5.810437101125717 2.6000000000000005  5.149116817116737 2.8739276736974717  4.661522245407105 3.3615222454071043  C 4.173927673697471 3.8491168171167374  3.900000000000002 4.510437101125717  3.9 5.2  C 3.9 5.2  5.2 5.2  5.2 5.2  C 5.2 4.855218550562859  5.336964146792888 4.524558718502521  5.580761432647705 4.280761432647705  C 5.824558718502522 4.036964146792889  6.155218550562858 3.899999999999999  6.5 3.9  C 6.844781449437141 3.899999999999999  7.175441281497479 4.036964146792889  7.419238567352295 4.280761432647705  C 7.663035853207111 4.524558718502521  7.8 4.855218550562859  7.8 5.2  C 7.8 6.5  5.8500000000000005 6.3374999999999995  5.8500000000000005 8.450000000000001  C 5.8500000000000005 8.450000000000001  7.15 8.450000000000001  7.15 8.450000000000001  C 7.15 6.9875  9.1 6.825  9.1 5.2  C 9.1 4.510437101125717  8.826072326302528 3.8491168171167374  8.338477754592896 3.3615222454071043  Z '
                              fillRule='nonzero'
                              fill='#9b9b9b'
                              stroke='none'
                              transform='matrix(1 0 0 1 528 225 )'
                            />
                          </g>
                        </svg>
                      </span>
                    </OverlayTrigger> */}
                  </h5>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  commonApiCall,
})(withRouter(TopPerformerStatics));
